import { render } from "./aws.vue?vue&type=template&id=cc41f5d6"
import script from "./aws.vue?vue&type=script&lang=js"
export * from "./aws.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__